import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { ProductsProvider } from './context/ProductsContext';
import ExperienceProvider from './components/Animation/ExperienceProvider';
import MainLayout from './layouts/MainLayout';
import ScrollToTop from './components/ScrollToTop';
import Logo from './components/Logo';

const Home = lazy(() => import('./pages/Home'));
const Shop = lazy(() => import('./pages/Shop'));
const ProductDetail = lazy(() => import('./pages/ProductDetail'));
const Cart = lazy(() => import('./pages/Cart'));
const Checkout = lazy(() => import('./pages/Checkout'));
const Contact = lazy(() => import('./pages/Contact'));
const About = lazy(() => import('./pages/About'));
const ReturnPolicy = lazy(() => import('./pages/ReturnPolicy'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-lumora-dark">
    <div className="flex flex-col items-center gap-4">
      <Logo size="hero" />
      <div className="w-12 h-12 border-2 border-lumora-gold/30 border-t-lumora-gold rounded-full animate-spin" />
    </div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ExperienceProvider>
        <CartProvider>
          <ProductsProvider>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route element={<MainLayout />}>
                <Route index element={<Home />} />
                <Route path="shop" element={<Shop />} />
                <Route path="product/:slug" element={<ProductDetail />} />
                <Route path="cart" element={<Cart />} />
                <Route path="checkout" element={<Checkout />} />
                <Route path="contact" element={<Contact />} />
                <Route path="about" element={<About />} />
                <Route path="return-policy" element={<ReturnPolicy />} />
              </Route>
            </Routes>
          </Suspense>
          </ProductsProvider>
        </CartProvider>
      </ExperienceProvider>
    </BrowserRouter>
  );
}

export default App;
